module.exports = {
	"sitedownloads": "https://storage.googleapis.com/windermere.data.insiteinteractive.com.au/live/data/sitedownloads",
	"masterplan": "https://storage.googleapis.com/windermere.data.insiteinteractive.com.au/live/data/masterplan",
	"precinctplan": "https://storage.googleapis.com/windermere.data.insiteinteractive.com.au/live/data/precinctplan",
	"stageplan": "https://storage.googleapis.com/windermere.data.insiteinteractive.com.au/live/data/stageplan",
	"lotplan": "https://storage.googleapis.com/windermere.data.insiteinteractive.com.au/live/data/lotplan",
	"landsearch": "https://storage.googleapis.com/windermere.data.insiteinteractive.com.au/live/data/landsearch",
	"searchfields": "https://storage.googleapis.com/windermere.data.insiteinteractive.com.au/live/data/searchfields",
	"packagesearch": "https://storage.googleapis.com/windermere.data.insiteinteractive.com.au/live/data/packagesearch",
	"package": "https://storage.googleapis.com/windermere.data.insiteinteractive.com.au/live/data/package",
	"location": "https://storage.googleapis.com/windermere.data.insiteinteractive.com.au/live/data/location",
	"spacerimage": "https://storage.googleapis.com/windermere.data.insiteinteractive.com.au/assets/images/spacer.png",
	"loadingimage": "https://storage.googleapis.com/windermere.data.insiteinteractive.com.au/assets/images/loading.gif",
	"googlemapsapikey": "AIzaSyB5h-u50GL0Ee6xVr93-vQdXWj_7yJahAQ",
	"activestatus": [
		1,
		3,
		6
	],
	"locationname": "Windermere",
	"mapresetlevel": 14,
	"mapcenterlat": -38.124134,
	"mapcenterlong": 145.329668
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/modules/config.json
 ** module id = 7
 ** module chunks = 0
 **/